import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';

import { emptyAccounts } from 'containers/Accounts/store/actions';
import { emptyApp } from 'containers/App/store/actions';
import { emptyAuth } from 'containers/Auth/store/actions';
import { emptyFreelancers } from 'containers/Freelancers/store/actions';
import { emptyMessaging } from 'containers/Messaging/store/actions';
import { emptyOpportunities } from 'containers/Opportunities/store/actions';
import { emptySearch } from 'containers/Search/store/actions';
import { clearError } from 'containers/Errors/store/actions';

import { LOCALSTORAGE } from 'utils/constants';

import PageContent from 'components/PageContent';
import LoadingCircle from 'components/LoadingCircle';

class LogoutPage extends React.Component {
    componentWillMount() {
        this.props.clearError();
        this.props.emptyAccounts();
        this.props.emptyApp();
        this.props.emptyAuth();
        this.props.emptyFreelancers();
        this.props.emptyMessaging();
        this.props.emptyOpportunities();
        this.props.emptySearch();

        localStorage.removeItem(LOCALSTORAGE.ID_TOKEN);

        let redirectUrl = `/login${this.props.location.query.redirect != null ? `?redirect=${this.props.location.query.redirect}` : ''}`;
        this.props.changeLocation(redirectUrl);
    }

    render() {
        return (
            <PageContent>
                <LoadingCircle />
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        clearError: () => dispatch(clearError()),
        emptyAccounts: () => dispatch(emptyAccounts()),
        emptyApp: () => dispatch(emptyApp()),
        emptyAuth: () => dispatch(emptyAuth()),
        emptyFreelancers: () => dispatch(emptyFreelancers()),
        emptyMessaging: () => dispatch(emptyMessaging()),
        emptyOpportunities: () => dispatch(emptyOpportunities()),
        emptySearch: () => dispatch(emptySearch())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPage);



// WEBPACK FOOTER //
// ./src/containers/Auth/LogoutPage/index.js